import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { settingsApi } from '@/api/settings';
import { AboutUsSettings, ContactSettings, SliderSettings } from '@/types';
import { useActionFeedback } from '@/hooks/useActionFeedback';

export const useContactSettings = () =>
  useQuery({
    queryKey: ['settings', 'contact'],
    queryFn: () => settingsApi.getContact(),
  });

export const useUpdateContactSettings = () => {
  const queryClient = useQueryClient();
  const feedback = useActionFeedback();

  return useMutation({
    mutationFn: (data: ContactSettings) => settingsApi.updateContact(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['settings', 'contact'] });
      feedback.success('Pengaturan kontak berhasil diperbarui');
    },
    onError: (error) => {
      feedback.error('Gagal memperbarui pengaturan kontak', error);
    },
  });
};

export const useAboutUsSettings = () =>
  useQuery({
    queryKey: ['settings', 'about-us'],
    queryFn: () => settingsApi.getAboutUs(),
  });

export const useUpdateAboutUsSettings = () => {
  const queryClient = useQueryClient();
  const feedback = useActionFeedback();

  return useMutation({
    mutationFn: (data: AboutUsSettings) => settingsApi.updateAboutUs(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['settings', 'about-us'] });
      feedback.success('Pengaturan About Us berhasil diperbarui');
    },
    onError: (error) => {
      feedback.error('Gagal memperbarui pengaturan About Us', error);
    },
  });
};

export const useHomePageSettings = () =>
  useQuery({
    queryKey: ['settings', 'homepage'],
    queryFn: () => settingsApi.getHomePage(),
  });

export const useUpdateHomePageSettings = () => {
  const queryClient = useQueryClient();
  const feedback = useActionFeedback();

  return useMutation({
    mutationFn: (data: SliderSettings) => settingsApi.updateHomePage(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['settings', 'homepage'] });
      feedback.success('Pengaturan slider berhasil diperbarui');
    },
    onError: (error) => {
      feedback.error('Gagal memperbarui pengaturan slider', error);
    },
  });
};
